module.exports = __webpack_public_path__ + "img/bid_thumb2.4f80949f.png";